











import {Component, Vue} from "vue-property-decorator";
import {AppModule} from "@/store/modules/app";
import SidebarContent from "./components/SidebarContent.vue";
import SidebarDesktop from "./components/SidebarDesktop.vue";
import SidebarMobile from "./components/SidebarMobile.vue";
import {DeviceType} from "@/enums/type";

@Component({
    name: 'Sidebar',
    components: {SidebarMobile, SidebarDesktop, SidebarContent}
})
export default class extends Vue {
    private deviceType = DeviceType;

    get device() {
        return AppModule.device;
    }
    get sidebar() {
        return AppModule.sidebar;
    }
    get collapsed() {
        return !this.sidebar.opened;
    }
    get visible() {
        return this.sidebar.opened;
    }
    private closeSidebar() {
        AppModule.CloseSidebar();
    }
}
